/* global document */
(function () {
  'use strict';

  class VideoLibraryCtrl {
    constructor($state) {
      if ($state.current.name === 'root.videoLibrary') {
        $state.go('root.videoLibrary.solicitacaoVideos');
        return;
      }

      /*eslint-disable */
      const elementContainer = document.querySelector('#video-library-tabs');
      if (elementContainer) {
        const vfwcVideoLibraryTabsElement = document.createElement('vfwc-video-library-tabs');
        vfwcVideoLibraryTabsElement.tabs = [
          {
              name: 'playlist',
              label: 'ce.analise.videoLibrary.tabs.playlist',
          },
        ];

        switch ($state.current.name) {
          default: {
            vfwcVideoLibraryTabsElement.initialTabIndex = 0;
          }
        }

        vfwcVideoLibraryTabsElement.addEventListener('tabChanged', (event) => {
          switch(event.detail) {
            default: $state.go('root.videoLibrary.solicitacaoVideos');
          }
        });

        elementContainer.appendChild(vfwcVideoLibraryTabsElement);
      $rootScope.$on('$translateChangeSuccess', () => {
          console.log('[VideoLibrary] idioma mudou — recarregando abas');

          elementContainer.innerHTML = '';
          const newTabs = document.createElement('vfwc-video-library-tabs');
          newTabs.tabs = [
            {
              name: 'playlist',
              label: 'ce.analise.videoLibrary.tabs.playlist',
            },
          ];
          newTabs.initialTabIndex = (vfwcVideoLibraryTabsElement.initialTabIndex != null)
            ? vfwcVideoLibraryTabsElement.initialTabIndex
            : 0;
          elementContainer.appendChild(newTabs);
        });
      }
    }
  }

  angular
    .module('relatorios.videoLibrary')
    .controller('VideoLibraryCtrl', VideoLibraryCtrl);
}());
